export default "__VITE_ASSET__99993cfe__"